import LoadableStore, { LoadingState } from '@migrate/stores/LoadableStore'
import { action, computed, observable } from 'mobx'
import { InvestorPortalConfig } from '@portal/pkg-api/gen/shared'

// Split out of PortalConfigAdapter.tsx so that module only exports components — `react-refresh`
// disables Fast Refresh for any file mixing component and non-component exports.

class PortalConfigStoreInternal extends LoadableStore {
  public readonly STORE_NAME = 'portalConfigStore'

  @observable private configBaseInternal?: InvestorPortalConfig
  @computed
  public get configBase(): InvestorPortalConfig {
    if (this.configBaseInternal) {
      return this.configBaseInternal
    }
    throw new Error('configBase called before initialized.')
  }

  @action
  setConfigBase(configBase: InvestorPortalConfig) {
    this.configBaseInternal = configBase
    this.state = LoadingState.LOADED
  }

  load(): Promise<void> {
    // Do nothing, wait for wrapper component query to resolve and set
    return Promise.resolve()
  }
}

export const PortalConfigStore = new PortalConfigStoreInternal()
